export const BROWSER_MACHINE_OPTIONS = [
  {
    id: 'useKaliLinux',
    value: 'Kali Linux',
    title: 'Use Kali Linux',
    subTitle: 'Web-based Kali Machine',
    type: 'button',
    handleClickSelectedOption: () => {},
  },
  {
    id: 'useAttackBox',
    value: 'AttackBox',
    title: 'Use AttackBox',
    subTitle: 'Recommended',
    type: 'button',
    handleClickSelectedOption: () => {},
  },
];
